import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { MammothMascot } from "../components/MammothMascot";
import { BrandLogo } from "../components/BrandLogo";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function Onboarding() {
  const [questions, setQuestions] = useState([]);
  const [idx, setIdx] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    api.get("/onboarding/quiz").then(r => setQuestions(r.data.questions)).catch(() => {});
  }, []);

  const pick = async (value) => {
    const next = [...answers, value];
    setAnswers(next);
    if (idx + 1 < questions.length) {
      setIdx(idx + 1);
    } else {
      setBusy(true);
      try {
        const { data } = await api.post("/onboarding/complete", { answers: next });
        setUser(data);
        toast.success(`Stage set: ${data.archetype}`);
        nav("/dashboard");
      } catch {
        toast.error("Couldn't save. Try again.");
        setBusy(false);
      }
    }
  };

  if (!questions.length) return <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#F5F5F0" }}>Preparing…</div>;
  const q = questions[idx];

  return (
    <div className="min-h-screen grain relative" style={{ backgroundColor: "#F5F5F0" }} data-testid="onboarding-page">
      <div className="max-w-4xl mx-auto px-6 pt-10 pb-20">
        <div className="mb-10">
          <BrandLogo width="clamp(130px, 14vw, 200px)" />
        </div>
        <div className="flex gap-2 mb-10">
          {questions.map((qq, i) => (
            <div key={qq.id} className={`h-1.5 flex-1 rounded-full ${i <= idx ? "bg-[#0e203b]" : "bg-[#0e203b]/10"}`} />
          ))}
        </div>
        <div key={q.id} className="animate-fadeUp">
          <div className="text-xs font-bold uppercase tracking-[0.25em] opacity-60">Question {idx + 1} of {questions.length}</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter leading-[1.02] mt-3" data-testid="quiz-question">{q.question}</h1>
          <div className="grid sm:grid-cols-2 gap-4 mt-10">
            {q.options.map((o, i) => (
              <button
                key={`${q.id}-${o.value}`}
                disabled={busy}
                onClick={() => pick(o.value)}
                data-testid={`quiz-option-${i}`}
                className="btn-pill text-left bg-white rounded-3xl p-6 border-2 border-[#0e203b]/5 hover:border-[#0e203b] shadow-sm"
              >
                <div className="font-display font-bold text-xl">{o.label}</div>
                <div className="text-xs uppercase tracking-widest opacity-50 mt-2">{o.value}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
